import React, { createContext, useReducer, ReactNode, useEffect } from "react";

interface SelectedRowsState {
  selectedRowsID: any;
  viewOrderPopup: boolean;
  approvalPopup: boolean;
}

const initialState: SelectedRowsState = {
  selectedRowsID: null,
  viewOrderPopup: false,
  approvalPopup: false,
};

type SelectedRowIDsAction =
  | { type: "SET_SELECTED_ROWS_IDS"; payload: number[] }
  | { type: "SET_VIEW_ORDER_POPUP"; payload: boolean }
  | { type: "SET_APPROVAL_POPUP"; payload: boolean };

export const selectedRowsState = createContext<{
  state: SelectedRowsState;
  dispatch: React.Dispatch<SelectedRowIDsAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const selectedRowIdsReducer = (
  state: SelectedRowsState,
  action: SelectedRowIDsAction
): SelectedRowsState => {
  switch (action.type) {
    case "SET_SELECTED_ROWS_IDS": {
      return { ...state, selectedRowsID: action.payload };
    }
    case "SET_VIEW_ORDER_POPUP": { 
      return { ...state, viewOrderPopup: action.payload };
    }
    case "SET_APPROVAL_POPUP": {
      return { ...state, approvalPopup: action.payload };
    }
    default:
      return state;
  }
};

interface SelectedRowIdsProviderProps {
  children: ReactNode;
}

export const SelectedRowIDSProvider: React.FC<SelectedRowIdsProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(selectedRowIdsReducer, initialState);

  useEffect(() => {
    const storageData = localStorage.getItem("applicationState");
    if (storageData) {
      const parsedData = JSON.parse(storageData);
      dispatch({
        type: "SET_SELECTED_ROWS_IDS",
        payload: parsedData.selectedRowsID,
      });
      dispatch({
        type: "SET_VIEW_ORDER_POPUP",
        payload: parsedData.viewOrderPopup || false,
      });
       dispatch({
        type: "SET_APPROVAL_POPUP",
        payload: parsedData.approvalPopup || false,
      });
    }
  }, []);

  return (
    <selectedRowsState.Provider value={{ state, dispatch }}>
      {children}
    </selectedRowsState.Provider>
  );
};

export default selectedRowsState;
